import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import macroRegionReadAction from './macroRegionRead.action.json' assert { type: 'json' }

const macroRegionReadDefinition = defineReadAutoAction(macroRegionReadAction, 'macroRegion')

export default macroRegionReadDefinition
